import { Box, styled } from '@mui/system'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import Dashboard from '../../components/Dashboard/Dashboard'
import Deposits from '../../components/Dashboard/Header/Deposits/Deposits'
import Sidebar from '../../components/Sidebar/Sidebar'
import { useDefaultComponentTools } from '../../hooks/useDefaultComponentTools'
import { selectSidebarIsOpen } from '../../store/redusers/sidebar/selectors'
import { selectShowTradingBar, selectUserId } from '../../store/redusers/user/selectors'


export const SidebarWrapper = styled(Box)(({theme, sidebar}) => ({
	background: theme.palette.background,
	opacity: sidebar ? 1 : 0,
	transition: '1s',
	[theme.breakpoints.down('lg')]: {
		height: '100vh',
		position: 'fixed',
		right: 0,
		top: 0,
		transition: '1s',
		width: '340px',
		zIndex: 10
	}
}))
export const DepositsBox = styled(Box)(({theme}) => ({
	[theme.breakpoints.down('lg')]: {
		bottom: 0,
		overflow: 'auto',
		position: 'fixed',
		width: '100%',
		zIndex: 1
	}
}))

function TradingPage() {
	const sidebarOpen = useSelector(selectSidebarIsOpen)
	const {lgUp, xxlDown} = useDefaultComponentTools()
	const [depositHeight, setDepositHeight] = useState(0)
	const elementRef = useRef(null)
	const isAuthorized = useSelector(selectUserId)
	const showTradingBar = useSelector(selectShowTradingBar)

	useEffect(() => {
		const element = elementRef?.current
		if (!element) return
		const observer = new ResizeObserver(() => {
			setDepositHeight(element.clientHeight)
		})
		observer.observe(element)
		return () => {
			observer.disconnect()
		}
	}, [isAuthorized])

	return (
		<Box  >
			<Box
				className='trading-page-wrapper'
				sx={{ display: lgUp ? 'grid' : 'flex',
					gridTemplateColumns:  sidebarOpen && lgUp ? `1fr ${xxlDown ? 300 : 340}px` : '1fr'
				}}
			>
				<Dashboard depositHeight={depositHeight}/>
				{sidebarOpen ?
					<Box sx={{position: 'relative'}}>
						<SidebarWrapper sidebar={sidebarOpen ? 1 : 0} >
							<Sidebar depositHeight={depositHeight}/>
						</SidebarWrapper>
					</Box> :
					null
				}
			</Box>
			{isAuthorized && showTradingBar ? <DepositsBox ref={elementRef} >
				<Deposits/>
			</DepositsBox> : null}
		</Box>
	)
}

export default TradingPage
